import React from "react";
import CommonLayout from "../CommonLayout";
import "./index.css";

const GrievanceRedressal: React.FC = () => {
  return (
    <CommonLayout>
      <iframe
        className="height100 width100 iframeClass noBorder"
        src="https://www.ink-aa.com/grievanceredressal"
        title="PrivacyAndPolicy"
        frameBorder="0"
        style={{ paddingTop: "20px", paddingBottom: "20px" }}
      />
    </CommonLayout>
  );
};

export default GrievanceRedressal;
